import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { paramCase, capitalCase } from 'change-case';
import { useEffect, useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import undoOutline from '@iconify/icons-eva/undo-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { Autorenew, BlockOutlined, CompareArrows, CopyAll, Delete, TaskAltOutlined } from '@material-ui/icons';
// material
import { useTheme } from '@material-ui/core/styles';
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, Typography, Grid, Stack, TextField, Autocomplete, Box, Button, Checkbox, FormControlLabel, Tab, Tabs } from '@material-ui/core';
// routes
import { PATH_DASHBOARD } from '../../../../routes/paths';
import axios from 'axios';
import { FacilityTypes, REST_API_END_POINT, UNITS } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import ConfirmationPopup from '../../official-request/ConfirmationPopup'
import Modal from '../../blog/ProjectModel';
import MaterialPartialFinishedProducts from 'src/pages/dashboard/MaterialPartialFinishedProducts';
import MaterialFinishedProducts from 'src/pages/dashboard/MaterialFinishedProducts';
import QbStockLog from 'src/pages/dashboard/QbStockLog';
import TransferHistory from 'src/pages/dashboard/TransferHistory';
import MaterialTransferLoader from 'src/components/MaterialTransferLoader';

const MATERIAL_TRANSFER_ACCOUNT_TABS = [
  { value: 'Partial Finished Products' },
  { value: 'Finished Products' },
  { value: 'QB LOG' },
  { value: 'Transfer History' },
];

// ----------------------------------------------------------------------

MaterialInventoryMenu.propTypes = {
  onDelete: PropTypes.func,
  userName: PropTypes.string,
  id: PropTypes.number,
  status: PropTypes.number,
  onEdit: PropTypes.func
};

export default function MaterialInventoryMenu({ materialTab, onMoveToClientOwned, setLoading, noDelete,showRefill,onDeletePartial,barcode,unit,unitName,onDelete,partialFinishedProducts, userName, id, unit_cost, qty, noEdit, status, fromFinishedProducts,fromInventoryAudit, onRefresh, onEdit ,setRefresh,maxQty,vpt_number,partial,hideMoveToPartial,isCatalog,page, rowsPerPage, row,datas,editId, materialTransferRow, fromListTransfer  }) {
  const ref = useRef(null);
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(false);
  const [openDeletePop,setOpenDeletePop] =useState(false)
  const [openPartialPop,setOpenPartialPop] =useState(false)
  const [partialModalOpen,setPartialModalOpen] =useState(false)
  const [movingQty,setMovingQty] =useState(1)
  const [convertionUnit,setConvertionUnit] =useState(null)
  const [convertionQty,setConvertionQty] =useState(0)
  const [convertionUnitPrice,setConvertionUnitPrice] =useState(0)
  const [convertionTotalPrice,setConvertionTotalPrice] =useState(0)
  const [autoFill,setAutoFill] =useState(true)
  const [openWastePop,setOpenWastePop] =useState(false)
  const [openDeletePartialPop,setOpenDeletePartialPop] =useState(false)
  const [openMovetoClientOwned,setOpenMovetoClientOwned] =useState(false)
  const [errors, setErrors] = useState({});
  const [wasteqty,setWasteQty] =useState(1)
  const [refillOpen,setRefillOpen] =useState(false)
  const [refillQty,setRefillQty] =useState('')
  const [openRefillPop,setOpenRefillPop] =useState(false)
  const [openTransferPop,setOpenTransferPop] =useState(false)
  const duplicateThrottleRef = useRef(false);
  const [duplicateDisabled, setDuplicateDisabled] = useState(false);
  const [deleteReason, setDeleteReason] = useState('');
  const [deleteReasonError, setDeleteReasonError] = useState('');
  const [transferProduct, setTransferProduct] = useState(false);
  const [transferFacility, setTransferFacility] = useState(null);
  const [partialTransferOpen, setPartialTransferOpen] = useState(false);
  const [openPartialTransferPop, setOpenPartialTransferPop] = useState(false);
  const [partialTransferFacility, setPartialTransferFacility] = useState(null);
  const [partialTransferQty, setPartialTransferQty] = useState('');
  const [partialTransferUnit, setPartialTransferUnit] = useState(null);
  const [partialTransferUnitCost, setPartialTransferUnitCost] = useState(0);
  const [partialTransferTotalCost, setPartialTransferTotalCost] = useState(0);
  const [partialTransferErrors, setPartialTransferErrors] = useState({});
  const [materialTransferLoading, setMaterialTransferLoading] = useState(false);
  const [openMaterialTransferLoaderModal, setOpenMaterialTransferLoaderModal] = useState(false);
  const [materialTransferLoaderMessage, setMaterialTransferLoaderMessage] = useState('Transferring material...');
  const [openMaterialPartialTransferModal, setOpenMaterialPartialTransferModal] = useState(false);
  const [materialTransferCurrentTab, setMaterialTransferCurrentTab] = useState('Finished Products');

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =userData?.exploded_permissions
  const getAvailableUnitQty = () => Number(datas?.unit_qty ?? qty ?? 0);
  const allowsZeroMovingQty = () => !transferProduct && getAvailableUnitQty() === 0;
  const getDefaultMovingQty = () => (allowsZeroMovingQty() ? 0 : 1);
  const resetPartialModalFields = () => {
    const defaultMovingQty = getDefaultMovingQty();
    const perUnitConvertion = Number(datas?.convertion_qty || 1);
    const productUnitCost = unit_cost || datas?.unit_cost || 0;
    const isZeroQtyProduct = allowsZeroMovingQty();
    setMovingQty(defaultMovingQty);
    setConvertionUnit(null);
    setConvertionQty(defaultMovingQty * perUnitConvertion);
    // For qty-0 products, keep unit_cost as-is; for normal products divide by perUnitConvertion.
    setConvertionUnitPrice(isZeroQtyProduct ? productUnitCost : (perUnitConvertion > 0 ? productUnitCost / perUnitConvertion : 0));
    setConvertionTotalPrice(productUnitCost * defaultMovingQty);
    setAutoFill(true);
  };
  const permissionToDeleteFinsished = explodedPermissions?.some(permission => ['Delete Finished Products'].includes(permission)) ? true : false
  const permissionToDeletePartial = explodedPermissions?.some(permission => ['Delete Partial Products'].includes(permission)) ? true : false
  const permissionToEditFinished = explodedPermissions?.some(permission => ['Edit Finished Products'].includes(permission)) ? true : false
  const permissionToEditPartial = explodedPermissions?.some(permission => ['Edit Partial Products'].includes(permission)) ? true : false
  console.log('permissions > ', 'delete-finished',permissionToDeleteFinsished,'edit-finished',permissionToEditFinished,'delete-partial',permissionToDeletePartial,'edit-partial',permissionToEditPartial)

  useEffect(() => {
    console.log('datas > ', datas)
    if (datas && partialModalOpen) {
      const availableQty = getAvailableUnitQty();
      const defaultMovingQty = availableQty === 0 && !transferProduct ? 0 : 1;
      const perUnitConvertion = Number(datas.convertion_qty || 1);
      const productUnitCost = unit_cost || datas.unit_cost || 0;
      const isZeroQtyProduct = availableQty === 0 && !transferProduct;

      setConvertionUnit(UNITS?.find((item) => item.id === datas.convertion_unit))
      setMovingQty(defaultMovingQty);
      setConvertionQty(defaultMovingQty * perUnitConvertion);
      // For qty-0 products, keep unit_cost as-is; for normal products divide by perUnitConvertion.
      setConvertionUnitPrice(isZeroQtyProduct ? productUnitCost : (perUnitConvertion > 0 ? productUnitCost / perUnitConvertion : 0));
      setConvertionTotalPrice(productUnitCost * defaultMovingQty);
    }
  }, [datas, partialModalOpen, transferProduct]);
  const changeStatus = async (prodId, prodStatus, reason = '') => {
    try {
      let id = prodId;
      let status = prodStatus;
      let response;
      let userId=userData?.user_id;
      // console.log("id-----", id, " status-----------", status)
      if(fromFinishedProducts){
        response = await axios.post(`${REST_API_END_POINT}product/delete-finished-product`,{id,userId : userData?.user_id, reason,editId})
      } else if(partialFinishedProducts){
        response = await axios.post(`${REST_API_END_POINT}product/delete-finished-product`,{id,userId : userData?.user_id, reason,editId})
      } else{
       response = await axios.post((`${REST_API_END_POINT}product/delete-product?id=${id}&status=${status}`),
        {
          reason,
          headers: {
            'Content-Type': 'application/json',
          },
        })
      }
      // console.log("response-----------------", response.data);
      if (response.data.status === 1 || response.data.status === 2 || response.data.status === 4) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      }
      else if (response.data.status === 0 || response.data.status === 3 || response.data.status === 5 || response.data.status === 500) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      else {
        console.log("Error.........!");
        enqueueSnackbar("Error.........!", { variant: 'error' });
      }
      (fromFinishedProducts || partialFinishedProducts) ? onRefresh(id) : navigate(PATH_DASHBOARD.products.material, { state: { data: true } });
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }

  const handleMenuItemClick = async (id, newStatus, reason = '') => {
    if ((fromInventoryAudit||fromFinishedProducts||partialFinishedProducts) && newStatus === 2 && !reason.trim()) {
      setDeleteReasonError('Reason is required');
      return;
    }
    setIsOpen(false)
    setOpenDeletePop(false);
    setDeleteReason('');
    setDeleteReasonError('');
    await changeStatus(id, newStatus, reason);
    if(!fromFinishedProducts && !partialFinishedProducts){
      navigate(PATH_DASHBOARD.products.material);
    }
  }

  const handleSubmitPartial = () => {
    const newErrors = {};
    const availableQty = getAvailableUnitQty();
    const isZeroStockProduct = allowsZeroMovingQty();
    const movingQtyNum = Number(movingQty);

    if (transferProduct && !transferFacility?.id) newErrors.transferFacility = "Facility Required";
    if (movingQty === "" || movingQty === null || movingQty === undefined) {
      newErrors.movingQty = "Required";
    } else if (movingQtyNum < 0 || (transferProduct && movingQtyNum <= 0) || movingQtyNum > availableQty) {
      newErrors.movingQty = movingQtyNum > availableQty
        ? `Cannot move more than available quantity (${availableQty})`
        : "Quantity must be greater than zero";
    }
    if (!convertionUnit) newErrors.convertionUnit = "Required";
    // Conversion qty required only when moving qty > 0 (zero-stock / zero-move can stay at 0)
    if (!isZeroStockProduct && movingQtyNum > 0 && (!convertionQty || convertionQty <= 0)) {
      newErrors.convertionQty = "Required";
    }
  
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    if (transferProduct) {
      setOpenTransferPop(true);
    } else {
      setOpenPartialPop(true);
    }
    setErrors({});
  };

  const handleSubmitRefill = () => {
    const newErrors = {};
    if (!refillQty || refillQty <= 0) newErrors.refillQty = "Required";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setOpenRefillPop(true);
    setErrors({});
  };

  const handleRefillFinishedProduct = async (id) => {
    try {
      setIsOpen(false);
      setRefillOpen(false);
      setOpenRefillPop(false);
      let response = await axios.post(`${REST_API_END_POINT}product/refill-finished-product`, 
        {userId:userData?.user_id, refillFinishedProductId:id, refillQty })
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      onRefresh(id);
    } catch (error) {
      console.error("Error : ", error);
    }
  }

  const handleMoveToPartial = async (id) => {
    try {
      setIsOpen(false);
      setPartialModalOpen(false);
      setOpenPartialPop(false);
      let response = await axios.post(`${REST_API_END_POINT}product/move-finished-product-partial`, 
        {userId:userData?.user_id,editFinishedProductId:id,movingQty,convertionUnit,convertionQty,convertionUnitPrice,convertionTotalPrice,autoFill })
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      onRefresh(id);
    } catch (error) {
      console.error("Error : ", error);
    }
  }

  const handleTransferMaterial = async () => {
    setOpenTransferPop(false);
    setMaterialTransferLoaderMessage(
      `Transferring ${userName} to ${transferFacility?.label || transferFacility?.name || 'facility'}...`
    );
    setOpenMaterialTransferLoaderModal(true);
    setMaterialTransferLoading(true);
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/transfer-material-to-facility`,
        { userId:userData?.user_id, materialInventoryId:id, transferFacility, targetFacilityId:transferFacility?.id, movingQty, convertionUnit, convertionQty, convertionUnitPrice, convertionTotalPrice })
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      onRefresh(id);
    } catch (error) {
      console.error("Error : ", error);
      enqueueSnackbar('Error transferring material', { variant: 'error' });
    } finally {
      setMaterialTransferLoading(false);
      setOpenMaterialTransferLoaderModal(false);
      setPartialModalOpen(false);
      setIsOpen(false);
    }
  }

  const getPartialTransferAvailableQty = () => Number(datas?.qty || qty || maxQty || 0);

  const resetPartialTransfer = () => {
    setPartialTransferOpen(false);
    setOpenPartialTransferPop(false);
    setPartialTransferFacility(null);
    setPartialTransferQty('');
    setPartialTransferUnit(null);
    setPartialTransferUnitCost(0);
    setPartialTransferTotalCost(0);
    setPartialTransferErrors({});
  }

  const handleOpenPartialTransfer = () => {
    const availableQty = getPartialTransferAvailableQty();
    const defaultQty = availableQty > 0 ? 1 : '';
    const defaultUnitCost = Number(datas?.unit_cost || unit_cost || 0);
    const defaultUnit = UNITS?.find((item) => item.id === (datas?.partial_unit || datas?.convertion_unit));

    setPartialTransferFacility(null);
    setPartialTransferQty(defaultQty);
    setPartialTransferUnit(defaultUnit || null);
    setPartialTransferUnitCost(defaultUnitCost);
    setPartialTransferTotalCost(defaultQty ? defaultUnitCost * Number(defaultQty) : 0);
    setPartialTransferErrors({});
    setPartialTransferOpen(true);
    setIsOpen(false);
  }

  const handleSubmitPartialTransfer = () => {
    const newErrors = {};
    const transferQty = Number(partialTransferQty || 0);
    const availableQty = getPartialTransferAvailableQty();

    if (!partialTransferFacility?.id) newErrors.partialTransferFacility = "Facility Required";
    if (!partialTransferUnit) newErrors.partialTransferUnit = "Required";
    if (!transferQty || transferQty <= 0) newErrors.partialTransferQty = "Required";
    if (transferQty > availableQty) newErrors.partialTransferQty = `Available quantity is ${availableQty}`;

    if (Object.keys(newErrors).length > 0) {
      setPartialTransferErrors(newErrors);
      return;
    }

    setPartialTransferErrors({});
    setOpenPartialTransferPop(true);
  }

  const handleTransferPartialMaterial = async () => {
    setOpenPartialTransferPop(false);
    const unitLabel = partialTransferUnit?.short_name || partialTransferUnit?.name || '';
    setMaterialTransferLoaderMessage(
      `Transferring ${partialTransferQty} ${unitLabel} of ${userName} to ${partialTransferFacility?.label || partialTransferFacility?.name || 'facility'}...`
    );
    setOpenMaterialTransferLoaderModal(true);
    setMaterialTransferLoading(true);
    try {
      const transferQty = Number(partialTransferQty || 0);
      const response = await axios.post(`${REST_API_END_POINT}product/transfer-material-to-facility`,
        {
          userId:userData?.user_id,
          materialInventoryId:id,
          transferFacility:partialTransferFacility,
          targetFacilityId:partialTransferFacility?.id,
          movingQty:transferQty,
          convertionUnit:partialTransferUnit,
          convertionQty:transferQty,
          convertionUnitPrice:partialTransferUnitCost,
          convertionTotalPrice:partialTransferTotalCost
        })
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      onRefresh(id);
    } catch (error) {
      console.error("Error : ", error);
      enqueueSnackbar('Error transferring partial product', { variant: 'error' });
    } finally {
      setMaterialTransferLoading(false);
      setOpenMaterialTransferLoaderModal(false);
      resetPartialTransfer();
      setIsOpen(false);
    }
  }

  const handleMoveToWaste = async (id) => {
    try {
      setIsOpen(false);
      setOpenWastePop(false);
      let response = await axios.post(`${REST_API_END_POINT}product/move-finished-product-to-waste`, 
        {userId:userData?.user_id,editFinishedProductId:id,wasteqty})
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      onRefresh(id);
    } catch (error) {
      console.error("Error : ", error);
    }
  }

  const handleDeletePartial = async (id) => {
    try {
      setIsOpen(false);
      setOpenDeletePartialPop(false);
      let response = await axios.post(`${REST_API_END_POINT}product/delete-partial-finished-product`, 
        { userId:userData?.user_id, deleteFinishedProductId:id })
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      onRefresh(id);
    } catch (error) {
      console.error("Error : ", error);
    }
  }

  const handleMoveToClientOwned = async (material_id) => {
    // setLoading(true);
    try {
      setIsOpen(false);
      setOpenMovetoClientOwned(false);
      let response = await axios.post(`${REST_API_END_POINT}product/move-to-client-owned`, 
        { userId:userData?.user_id, id:material_id })
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      setRefresh(true);
    } catch (error) {
      console.error("Error : ", error);
    }finally{
      setLoading(false);
    }
  }
  const handleOpenMoveToPartial = async () => {
    // try {
    //   let response = await axios.post(`${REST_API_END_POINT}product/get-finished-product-by-id`, 
    //     { userId:userData?.user_id,editFinishedProductId:id,fromMaterial:true })
    //   if (response.data.status === 1) {
        // setFinishedProductData(response.data.data);
        setTransferProduct(false);
        setPartialModalOpen(true);
        setIsOpen(false);
    //   } else {
    //     enqueueSnackbar(response.data.message, { variant: 'error' });
    //   }
    // }catch(error){
    //   console.error("Error : ", error);
    // }
   
  }

  const handleOpenTransferProduct = () => {
    if (partialFinishedProducts) {
      handleOpenPartialTransfer();
      return;
    }
    setTransferProduct(true);
    setPartialModalOpen(true);
    setIsOpen(false);
  }

  const handleOpenMaterialPartialTransfer = () => {
    setMaterialTransferCurrentTab('Finished Products');
    setOpenMaterialPartialTransferModal(true);
    setIsOpen(false);
  }

  const handleCloseMaterialPartialTransfer = () => {
    setOpenMaterialPartialTransferModal(false);
    setMaterialTransferCurrentTab('Finished Products');
    if (setRefresh) {
      setRefresh(true);
    }
  }

  const handleMaterialTransferTabChange = (event, newValue) => {
    setMaterialTransferCurrentTab(newValue);
  }

  const getMaterialTransferUnitName = () => {
    if (materialTransferRow?.unit_name) {
      return materialTransferRow.unit_name;
    }
    return UNITS?.find((item) => item.id === materialTransferRow?.unit)?.name || '';
  }
  // const handleDuplicate=async()=>{
  //   if (duplicateThrottleRef.current) return;
  
  //   // Lock future calls
  //   duplicateThrottleRef.current = true;
  //   setDuplicateDisabled(true);
  //   setIsOpen(false);
  //   let res = await axios.post(`${REST_API_END_POINT}product/duplicate`,{
  //     id,
  //    })
  //     if(res.data.status ==1){
  //       enqueueSnackbar(res.data.message,{variant:'success'})
  //       setRefresh(true)
  //     }else if( res.data.status ==0){
  //       enqueueSnackbar(res.data.message,{variant:'success'})
        
  //     }else{
  //     enqueueSnackbar(res.data.message,{variant:'success'})
  
  //     } 
  //  }

  const handleDuplicate = async () => {
    if (duplicateThrottleRef.current) return;
  
    // Lock future calls
    duplicateThrottleRef.current = true;
    setDuplicateDisabled(true);
    setIsOpen(false);
  
    try {
      const res = await axios.post(`${REST_API_END_POINT}product/duplicate`, { id });
  
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRefresh(true);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Something went wrong!', { variant: 'error' });
    } finally {
      // Unlock after 1 second (throttle time)
      setTimeout(() => {
        duplicateThrottleRef.current = false;
        setDuplicateDisabled(false);
      }, 1000);
    }
  };

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>
      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {fromListTransfer && (fromFinishedProducts || partialFinishedProducts) && !fromInventoryAudit ? (
          <MenuItem onClick={handleOpenTransferProduct}>
            <ListItemIcon>
              <CompareArrows sx={{ width: 24, height: 24 }} />
            </ListItemIcon>
            <ListItemText primary="Transfer Material" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        ) : (
        <>
        {(fromFinishedProducts || partialFinishedProducts) && onEdit ? (
            !noEdit ? 
            <>
              <MenuItem
                onClick={()=>{
                if (
                  (!partial && permissionToEditFinished) ||
                  (partial && permissionToEditPartial)
                ) {
                  onEdit(id);
                  setIsOpen(false);
                } else {
                  enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
                    variant: 'error',
                  })
                }
                }}
              >
                <ListItemIcon>
                  <Icon icon={editFill} width={24} height={24} />
                </ListItemIcon>
                <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
              </MenuItem>
            </>
            : ""
        ) : (
          [
            <MenuItem
              key="edit"
              disabled={explodedPermissions?.some(permission => ['Edit Material Label'].includes(permission)) ? false : true}
              onClick={async ()=>{
                if(status==1){
                  if(onEdit){
                    onEdit(id);
                    setIsOpen(false);
                  } else {
                    try {
                      await axios.post(`${REST_API_END_POINT}product/mark-viewed`, { id });
                    } catch (error) {
                      console.error('Failed to clear material new flag on edit', error);
                    }
                    navigate(`${PATH_DASHBOARD.products.editMaterial}?id=${id}/edit`, {
                      state: {
                        materialTab: materialTab,
                        listPage: page ?? 0,
                        rowsPerPage: rowsPerPage ?? 25,
                        scrollToProductId: row?.id ?? id
                      }
                    });
                    setIsOpen(false);
                  }
                } else {
                  enqueueSnackbar('Inactive material. Please activate to edit.', { variant: 'warning' });
                  setIsOpen(false);
                }
              }}
            >
              <ListItemIcon>
                <Icon icon={editFill} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>,
            <MenuItem key="duplicate" disabled={duplicateDisabled} onClick={() => { handleDuplicate(); }}>
              <ListItemIcon>
                <CopyAll icon={CopyAll} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="Duplicate" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>,
            materialTransferRow ? (
              <MenuItem key="transfer-material" onClick={handleOpenMaterialPartialTransfer}>
                <ListItemIcon>
                  <CompareArrows sx={{ width: 24, height: 24 }} />
                </ListItemIcon>
                <ListItemText primary="Transfer Material" primaryTypographyProps={{ variant: 'body2' }} />
              </MenuItem>
            ) : null
          ]
        )}

        {(fromFinishedProducts || partialFinishedProducts) ? '' : (status === 1 ? (
          <MenuItem
          disabled={explodedPermissions?.some(permission => ['Activate/Deactivate Material Label'].includes(permission)) ? false : true}
          onClick={() => handleMenuItemClick(id, 0)}
          >
            <ListItemIcon>
              <BlockOutlined sx={{ width: 25, height: 25 }} />
            </ListItemIcon>
            <ListItemText primary="Deactivate" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        ) : (
          <MenuItem
          disabled={explodedPermissions?.some(permission => ['Activate/Deactivate Material Label'].includes(permission)) ? false : true}
          onClick={() => handleMenuItemClick(id, 1)}
          >
            <ListItemIcon>
              <TaskAltOutlined sx={{ width: 25, height: 25 }} />
            </ListItemIcon>
            <ListItemText primary="Activate" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        ))}

        {noDelete ? '' :
        (( !partialFinishedProducts && permissionToDeleteFinsished) && 
        // ((!fromInventoryAudit && !partialFinishedProducts && permissionToDeleteFinsished) && 
        <MenuItem
        // disabled={explodedPermissions?.some(permission => ['Delete Material Label'].includes(permission)) ? false : true}
        onClick={() => {
          setDeleteReason('');
          setDeleteReasonError('');
          setOpenDeletePop(true);
          setIsOpen(false);
        }}>
          <ListItemIcon>
          <Icon icon={trash2Outline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>)}

        {(partialFinishedProducts && !fromInventoryAudit) && <MenuItem onClick={()=>{setOpenWastePop(true),setIsOpen(false)}}>
          <ListItemIcon>
          <Icon icon={trash2Outline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Move to Waste" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>}

        {((fromFinishedProducts || partialFinishedProducts) && !fromInventoryAudit) && <MenuItem onClick={handleOpenTransferProduct}>
          <ListItemIcon>
            <CompareArrows sx={{ width: 24, height: 24 }} />
          </ListItemIcon>
          <ListItemText primary="Transfer Material" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>}

        {/* {(fromFinishedProducts && !fromInventoryAudit) && (!isCatalog) && <MenuItem onClick={()=>{setPartialModalOpen(true),setIsOpen(false)}}> */}
        {(fromFinishedProducts && !fromInventoryAudit) && (!isCatalog) && <MenuItem onClick={()=>{handleOpenMoveToPartial()}}>
          <ListItemIcon>
          <Icon icon={undoOutline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Move to Partial" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>}

        {(fromFinishedProducts && showRefill && permissionToEditFinished) && <MenuItem onClick={()=>{setRefillOpen(true),setIsOpen(false)}}>
          <ListItemIcon>
          <Autorenew width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Refill" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>}

        {((onDeletePartial && permissionToDeletePartial) )&& <MenuItem onClick={()=>{setOpenDeletePartialPop(true),setIsOpen(false)}}>
          <ListItemIcon>
            {/* <Icon icon={trash2Outline} width={24} height={24} /> */}
            <Delete width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>}

        {onMoveToClientOwned && <MenuItem onClick={()=>{setOpenMovetoClientOwned(true),setIsOpen(false)}}>
          <ListItemIcon>
            <Icon icon={undoOutline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Move to Client Owned" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>}
        </>
        )}
      </Menu>

    {/* Confirmation for deleting product  */}
    <ConfirmationPopup 
      open={openDeletePop}
      handleClose={() => {
        setDeleteReason('');
        setDeleteReasonError('');
        setOpenDeletePop(false);
      }}
      message={`You want to delete ${userName} ! `}
      handleClick={() => {handleMenuItemClick(id, 2, deleteReason)}}
      showReasonField={fromInventoryAudit || fromFinishedProducts || partialFinishedProducts}
      reasonValue={deleteReason}
      onReasonChange={(value) => {
        setDeleteReason(value);
        if (value.trim()) {
          setDeleteReasonError('');
        }
      }}
      reasonLabel="Reason for delete"
      reasonRequired
      reasonError={deleteReasonError}
    />
    <ConfirmationPopup 
      open={openPartialPop}
      handleClose={()=>{setOpenPartialPop(false)}}
      message={`You want to move ${userName} to partial! `}
      handleClick={()=>{handleMoveToPartial(id)}}
    />
    <ConfirmationPopup 
      open={openTransferPop}
      handleClose={() => setOpenTransferPop(false)}
      message={`You want to transfer ${userName} to ${transferFacility?.label || transferFacility?.name}! `}
      handleClick={() => { handleTransferMaterial(); }}
    />
    <ConfirmationPopup 
      open={openPartialTransferPop}
      handleClose={() => setOpenPartialTransferPop(false)}
      message={`You want to transfer ${partialTransferQty} ${partialTransferUnit?.short_name || partialTransferUnit?.name || ''} of ${userName} to ${partialTransferFacility?.label || partialTransferFacility?.name}! `}
      handleClick={() => { handleTransferPartialMaterial(); }}
    />
    <Modal
      modalTitle="Transfer in progress"
      open={openMaterialTransferLoaderModal}
      width={520}
      hideCloseButton
      handleClose={() => {}}
    >
      <Box sx={{ minHeight: 280, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <MaterialTransferLoader message={materialTransferLoaderMessage} />
      </Box>
    </Modal>
    <ConfirmationPopup 
      open={openRefillPop}
      handleClose={()=>{setOpenRefillPop(false)}}
      message={`You want to refill ${userName} (${barcode}) `}
      handleClick={()=>{handleRefillFinishedProduct(id)}}
    />
    <ConfirmationPopup 
      open={openWastePop}
      handleClose={()=>{setOpenWastePop(false)}}
      message={`You want to move quantity of ${wasteqty} ${userName} to waste! `}
      handleClick={()=>{handleMoveToWaste(id)}}
      setWasteQty={setWasteQty}
      wasteqty={wasteqty}
      moveToWaste={true}
      maxQty={maxQty}
    />
    <ConfirmationPopup 
      open={openDeletePartialPop}
      handleClose={()=>{setOpenDeletePartialPop(false)}}
      message={`You want to delete ${barcode} of ${userName} `}
      handleClick={()=>{handleDeletePartial(id)}}
    />
    <ConfirmationPopup 
      open={openMovetoClientOwned}
      handleClose={()=>{setOpenMovetoClientOwned(false)}}
      message={`You want to transfer ${userName} to Client Owned`}
      handleClick={()=>{handleMoveToClientOwned(id)}}
    />
    <Modal
      modalTitle={transferProduct ? 'Transfer Material' : 'Move Finished Product to Partial'}
      open={partialModalOpen}
      handleClose={() => {
        setOpenPartialPop(false); 
        setPartialModalOpen(false);
        setTransferProduct(false);
        setTransferFacility(null);
        resetPartialModalFields();
      }}
    >
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={8}>
          <Stack spacing={3}>
            <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
              {transferProduct && (
                <Autocomplete
                  fullWidth
                  options={FacilityTypes?.filter(item => !item.default) || []}
                  value={transferFacility}
                  onChange={(event, newValue) => {
                    setTransferFacility(newValue);
                    setErrors((prev) => ({ ...prev, transferFacility: "" }));
                  }}
                  getOptionLabel={(option) => option?.label || option?.name || ''}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      error={!!errors.transferFacility}
                      helperText={errors.transferFacility}
                      label="Select facility"
                    />
                  )}
                />
              )}
              <TextField
                fullWidth
                label={transferProduct ? `${unitName} Qty to be transferred` : unitName + ' Qty to be moved'}
                type="number"
                disabled={allowsZeroMovingQty()}
                inputProps={{ min: transferProduct ? 1 : 0 }}
                onKeyPress={(event) => {
                  if (
                    event.key === '-' ||
                    event.key === '+' ||
                    event.key === 'e' ||
                    event.key === '.' ||
                    event.key === ',' ||
                    event.key === ' '
                  ) {
                    event.preventDefault();
                  }
                  // Transfer still cannot start with 0; move-to-partial allows 0
                  if (transferProduct && event.key === '0' && (!event.target.value || event.target.value === '0')) {
                    event.preventDefault();
                  }
                }}
                value={movingQty}
                onChange={(e) => {
                  const isZeroStockProduct = allowsZeroMovingQty();
                  const availableQty = getAvailableUnitQty();
                  let inputQty = e.target.value;
                  // Strip leading zeros only for transfer (move-to-partial may be 0)
                  if (transferProduct) {
                    inputQty = inputQty.replace(/^0+/, '');
                  }
                  if (inputQty === "") {
                    setMovingQty("");
                    setErrors((prev) => ({ ...prev, movingQty: "Required" }));
                    return;
                  }
                  let qtyNum = Number(inputQty);
                  if (qtyNum < 0 || (transferProduct && qtyNum <= 0)) {
                    setMovingQty("");
                    setErrors((prev) => ({ ...prev, movingQty: "Quantity must be greater than zero" }));
                    return;
                  }
                  if (qtyNum > availableQty) {
                    qtyNum = availableQty;
                  }
                  setMovingQty(qtyNum);
                  const perUnitConvertion = datas?.convertion_qty || 1;
                  const newConvertionQty = qtyNum * (perUnitConvertion || 1);
                  // Keep unit cost even when moving qty is 0 (zero-stock keeps material unit_cost as-is)
                  const unitCost = isZeroStockProduct
                    ? unit_cost
                    : (perUnitConvertion > 0 ? unit_cost / perUnitConvertion : 0);
                  setConvertionQty(newConvertionQty);
                  setConvertionUnitPrice(unitCost);
                  setConvertionTotalPrice(unit_cost * qtyNum);
                  setErrors((prev) => ({ ...prev, movingQty: "" }));
                }}
                error={!!errors.movingQty}
                helperText={errors.movingQty}
              />
              <Autocomplete
                fullWidth
                id="combo-box-demo"
                options={UNITS}
                // options={
                //   unit == 4 
                //     ? UNITS 
                //     : UNITS?.filter(item => {
                //         const foundUnit = UNITS.find(u => u.id === unit);
                //         return foundUnit ? item.unit_id === foundUnit.unit_id : false;
                //       })
                // }
                value={convertionUnit}
                disabled={!!datas?.convertion_unit}
                onChange={(event, newValue) =>{
                  setConvertionUnit(newValue)
                  setErrors((prev) => ({ ...prev, convertionUnit: "" }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params} required
                    error={!!errors.convertionUnit}
                    helperText={errors.convertionUnit}
                    label="Select a conversion unit"
                  />
                )}
                getOptionLabel={(option) => option.name ? option.name : ''}
              />
              <TextField
                fullWidth
                label={convertionUnit ? `${convertionUnit?.short_name} Qty` : "Conversion Qty"}
                type="number"
                disabled={!!datas?.convertion_unit || allowsZeroMovingQty()}
                onKeyPress={(event) => {
                  if (!allowsZeroMovingQty() && event.key === '0' && event.target.value === '0' ) {
                    event.preventDefault();
                  }
                  if (event.key === '-' || event.key === '+' || event.key === 'e' ) {
                    event.preventDefault();
                  }
                }}
                value={convertionQty === 0 ? 0 : (convertionQty || "")}
                onChange={(e) => {
                  let inputValue = parseFloat(e.target.value) || 0;
                  let unitCost = inputValue > 0 ? unit_cost / inputValue : 0;
                  setConvertionQty(inputValue);
                  setConvertionUnitPrice(unitCost);
                  setConvertionTotalPrice(unitCost * inputValue);
                  setErrors((prev) => ({ ...prev, convertionQty: "" }));
                }}
                error={!!errors.convertionQty}
                helperText={errors.convertionQty}
              />

              <TextField
                fullWidth
                label={'Unit Cost'}
                type="number"
                disabled
                value={convertionUnitPrice ? parseFloat(convertionUnitPrice || 0)?.toFixed(2) : 0}
              />
              <TextField
                fullWidth
                label={'Total Cost'}
                type="number"
                disabled
                value={convertionTotalPrice ? parseFloat(convertionTotalPrice || 0)?.toFixed(2) : 0}
              />
              {!transferProduct && (
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={autoFill}
                      onChange={(event) => setAutoFill(event.target.checked)}
                    />
                  }
                  label="Automate the process"
                />
              )}
              {/* <TextField
                fullWidth
                label={'Total Cost'}
                type="number"
                disabled
                value={convertionTotalPrice ? parseFloat(convertionTotalPrice || 0)?.toFixed(2) : ""}
              /> */}
            </Stack>

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="submit" variant="contained" onClick={handleSubmitPartial}>
                {transferProduct ? 'Transfer Material' : 'Move to Partial'}
              </Button>
              <Button variant="outlined" 
                onClick={()=>{
                  setOpenPartialPop(false); 
                  setPartialModalOpen(false);
                  setTransferProduct(false);
                  setTransferFacility(null);
                  resetPartialModalFields();
                }}
                sx={{ marginLeft: '10px' }}>
                Cancel
              </Button>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Modal>
    <Modal
      modalTitle={'Transfer Partial Product'}
      open={partialTransferOpen}
      handleClose={resetPartialTransfer}
    >
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={8}>
          <Stack spacing={3}>
            <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
              <Autocomplete
                fullWidth
                options={FacilityTypes?.filter(item => !item.default) || []}
                value={partialTransferFacility}
                onChange={(event, newValue) => {
                  setPartialTransferFacility(newValue);
                  setPartialTransferErrors((prev) => ({ ...prev, partialTransferFacility: "" }));
                }}
                getOptionLabel={(option) => option?.label || option?.name || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    error={!!partialTransferErrors.partialTransferFacility}
                    helperText={partialTransferErrors.partialTransferFacility}
                    label="Select facility"
                  />
                )}
              />
              <Autocomplete
                fullWidth
                options={UNITS}
                value={partialTransferUnit}
                disabled={!!(datas?.partial_unit || datas?.convertion_unit)}
                onChange={(event, newValue) => {
                  setPartialTransferUnit(newValue);
                  setPartialTransferErrors((prev) => ({ ...prev, partialTransferUnit: "" }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    error={!!partialTransferErrors.partialTransferUnit}
                    helperText={partialTransferErrors.partialTransferUnit}
                    label="Select a conversion unit"
                  />
                )}
                getOptionLabel={(option) => option.name ? option.name : ''}
              />
              <TextField
                fullWidth
                label={partialTransferUnit ? `${partialTransferUnit?.short_name} Qty` : "Conversion Qty"}
                type="number"
                inputProps={{ min: 1, max: getPartialTransferAvailableQty() }}
                value={partialTransferQty}
                onKeyPress={(event) => {
                  if (event.key === '-' || event.key === '+' || event.key === 'e') {
                    event.preventDefault();
                  }
                }}
                onChange={(e) => {
                  let inputValue = parseFloat(e.target.value) || '';
                  const availableQty = getPartialTransferAvailableQty();
                  if (inputValue > availableQty) {
                    inputValue = availableQty;
                  }
                  setPartialTransferQty(inputValue);
                  setPartialTransferTotalCost(Number(partialTransferUnitCost || 0) * Number(inputValue || 0));
                  setPartialTransferErrors((prev) => ({ ...prev, partialTransferQty: "" }));
                }}
                error={!!partialTransferErrors.partialTransferQty}
                helperText={partialTransferErrors.partialTransferQty || `Available Qty: ${getPartialTransferAvailableQty()}`}
              />
              <TextField
                fullWidth
                label={'Unit Cost'}
                type="number"
                disabled
                value={partialTransferUnitCost ? parseFloat(partialTransferUnitCost || 0)?.toFixed(2) : 0}
              />
              <TextField
                fullWidth
                label={'Total Cost'}
                type="number"
                disabled
                value={partialTransferTotalCost ? parseFloat(partialTransferTotalCost || 0)?.toFixed(2) : 0}
              />
            </Stack>
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="submit" variant="contained" onClick={handleSubmitPartialTransfer}>
                Transfer Partial Product
              </Button>
              <Button variant="outlined" onClick={resetPartialTransfer} sx={{ marginLeft: '10px' }}>
                Cancel
              </Button>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Modal>
    <Modal
      modalTitle={'Transfer Material'}
      open={openMaterialPartialTransferModal}
      width={1200}
      handleClose={handleCloseMaterialPartialTransfer}
    >
      {materialTransferRow && (
        <Box sx={{ maxHeight: '80vh', overflow: 'auto' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Tabs
                value={materialTransferCurrentTab}
                scrollButtons="auto"
                variant="scrollable"
                allowScrollButtonsMobile
                onChange={handleMaterialTransferTabChange}
                sx={{ mb: 2.5 }}
              >
                {MATERIAL_TRANSFER_ACCOUNT_TABS.map((tab) => (
                  <Tab
                    sx={{
                      justifyContent: 'center',
                      marginX: 6,
                      mt: 2.5,
                      overflow: 'visible',
                    }}
                    disableRipple
                    key={tab.value}
                    label={
                      <Typography variant="overline">{capitalCase(tab.value)}</Typography>
                    }
                    icon={tab.icon}
                    value={tab.value}
                  />
                ))}
              </Tabs>
            </Grid>
            {MATERIAL_TRANSFER_ACCOUNT_TABS.map((tab) => {
              const isMatched = tab.value === materialTransferCurrentTab;
              return (
                isMatched && (
                  <Grid item xs={12} key={tab.value}>
                    <Box
                      sx={{
                        width: '100%',
                        minWidth: 0,
                        maxWidth: '100%',
                        display: 'block',
                      }}
                    >
                      {materialTransferCurrentTab === 'Finished Products' ? (
                        <MaterialFinishedProducts
                          fromListTransfer
                          materialTab={materialTab}
                          prodId={materialTransferRow.id}
                          unitName={getMaterialTransferUnitName()}
                          unit={materialTransferRow.unit}
                          unitQty={materialTransferRow.unit_qty}
                          expectedPrice={materialTransferRow.price}
                          vpt_number={materialTransferRow.vpt_number}
                          description={materialTransferRow.description}
                        />
                      ) : materialTransferCurrentTab === 'Partial Finished Products' ? (
                        <MaterialPartialFinishedProducts
                          fromListTransfer
                          prodId={materialTransferRow.id}
                          unitName={getMaterialTransferUnitName()}
                          unit={materialTransferRow.unit}
                          unitQty={materialTransferRow.unit_qty}
                          expectedPrice={materialTransferRow.price}
                          vpt_number={materialTransferRow.vpt_number}
                          description={materialTransferRow.description}
                        />
                      ) : materialTransferCurrentTab === 'QB LOG' ? (
                        <QbStockLog quickbookId={materialTransferRow?.quickbookId} />
                      ) : materialTransferCurrentTab === 'Transfer History' ? (
                        <TransferHistory key={materialTransferRow.id} prodId={materialTransferRow.id} />
                      ) : (
                        ''
                      )}
                    </Box>
                  </Grid>
                )
              );
            })}
          </Grid>
        </Box>
      )}
    </Modal>
    <Modal
      modalTitle={'Refill Finished Product'}
      open={refillOpen}
      handleClose={() => {
        setRefillOpen(false);
        setOpenRefillPop(false);
      }}
    >
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={8}>
          <Stack spacing={3}>
            <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
              <TextField
                fullWidth
                label={unitName + ' Quantity to be added'}
                type="number"
                onKeyPress={(event) => {
                  if (event.key === '0' && event.target.value === '0' ) {
                    event.preventDefault();
                  }
                  // if (event.key === '0' && event.target.value === '' ) {
                  //   event.preventDefault();
                  // }
                  if (event.key === '-' || event.key === '+' || event.key === 'e' ) {
                    event.preventDefault();
                  }
                }}
                value={refillQty}
                onChange={(e) => {
                  let inputQty = e.target.value || 1;
                  setRefillQty(inputQty);
                  setErrors((prev) => ({ ...prev, refillQty: "" }));
                }}
                error={!!errors.refillQty}
                helperText={errors.refillQty}
              />
            </Stack>

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="submit" variant="contained" onClick={handleSubmitRefill}>
                Refill
              </Button>
              <Button variant="outlined" 
                onClick={()=>{
                  setRefillOpen(false);
                  setOpenRefillPop(false);
                }}
                sx={{ marginLeft: '10px' }}>
                Cancel
              </Button>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Modal>
    </>
  );
}
